import { render } from "./InvoiceDetailTabDocuments.vue?vue&type=template&id=a543a00a&scoped=true"
import script from "./InvoiceDetailTabDocuments.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTabDocuments.vue?vue&type=script&lang=js"

import "./InvoiceDetailTabDocuments.vue?vue&type=style&index=0&id=a543a00a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a543a00a"]])

export default __exports__